import { Box, Card, Divider, Stack, Typography, Chip } from "@mui/material";
import { Inventory } from "@mui/icons-material";
import { useTranslation } from "../../../../hooks/useTranslation";
import { CopiableChip } from "../../../../components/ui/CopiableChip";
import { SectionHeader } from "../../../../components/ui/SectionHeader";
import { SupplyOrder } from "../../types";

type Props = {
  supplyOrder: SupplyOrder;
};

export const SupplyOrderRow = ({ supplyOrder }: Props) => {
  const { translate } = useTranslation("pages.orderDetails.supplyOrders");

  return (
    <Card
      elevation={0}
      sx={{
        p: 2.5,
        backgroundColor: (theme) => theme.palette.customBackground.box,
      }}
    >
      <SectionHeader
        icon={<Inventory sx={{ fontSize: 20, color: "secondary.main" }} />}
        title={`${translate("title")} ${supplyOrder.id}`}
        color="secondary"
        action={
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip
              size="small"
              color="secondary"
              sx={{ fontWeight: 500, color: "white" }}
              label={translate(`status.${supplyOrder.status}`, {
                defaultValue: supplyOrder.status,
              })}
            />
            <CopiableChip initialLabel={supplyOrder.amazonSupplyOrderId} />
          </Stack>
        }
      />

      <Divider sx={{ my: 2 }} />

      <Stack spacing={1}>
        {supplyOrder.supplyOrderItems.map((item) => (
          <Box
            key={item.id}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 1,
              py: 0.75,
              borderRadius: 1,
              backgroundColor: "action.hover",
            }}
          >
            <CopiableChip initialLabel={item.productCode.toUpperCase()} />

            <Typography variant="body2">
              {translate("quantity")}: {item.quantity}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Card>
  );
};
